/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiQuickInsightCategory;
(function (ApiQuickInsightCategory) {
    ApiQuickInsightCategory["UNSPECIFIED"] = "QUICK_INSIGHT_CATEGORY_UNSPECIFIED";
    ApiQuickInsightCategory["CUSTOMERS_RETENTION"] = "QUICK_INSIGHT_CATEGORY_CUSTOMERS_RETENTION";
    ApiQuickInsightCategory["TIMING"] = "QUICK_INSIGHT_CATEGORY_TIMING";
    ApiQuickInsightCategory["PRODUCT"] = "QUICK_INSIGHT_CATEGORY_PRODUCT";
    ApiQuickInsightCategory["ACQUISITION"] = "QUICK_INSIGHT_CATEGORY_ACQUISITION";
})(ApiQuickInsightCategory || (ApiQuickInsightCategory = {}));
export function ApiQuickInsightCategoryFromJSON(json) {
    return ApiQuickInsightCategoryFromJSONTyped(json, false);
}
export function ApiQuickInsightCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiQuickInsightCategoryToJSON(value) {
    return value;
}
